import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateWordTemplateDto } from './create-word-template.dto';
import { WordTemplate } from './word-template.model';
import { AoAuthService } from '@ah-oh/company-auth';

@Injectable({
    providedIn: 'root',
})
export class WordTemplatesService {
    private static readonly BASE_URL = environment.documentApi + 'word-templater';

    constructor(
        private readonly http: HttpClient,
        private readonly authService: AoAuthService,
    ) {}

    public findAll(): Observable<WordTemplate[]> {
        return this.http.get<WordTemplate[]>(`${WordTemplatesService.BASE_URL}/${this.authService.companyId}`);
    }

    public create({ dto, file }: { dto: CreateWordTemplateDto; file: File }): Observable<HttpEvent<WordTemplate>> {
        let params: HttpParams = new HttpParams();
        for (const [key, value] of Object.entries(dto)) {
            if (key === 'tags') {
                params = params.append(key, (<string[]>value).join(','));
            } else {
                params = params.append(key, String(value));
            }
        }

        const data = new FormData();
        data.append('file', file);

        return this.http.post<WordTemplate>(`${WordTemplatesService.BASE_URL}/${this.authService.companyId}`, data, {
            reportProgress: true,
            observe: 'events',
            params,
        });
    }
    public update({ id, file }: { id: string; file: File }): Observable<HttpEvent<WordTemplate>> {
        const data = new FormData();
        data.append('file', file);

        return this.http.post<WordTemplate>(
            `${WordTemplatesService.BASE_URL}/${this.authService.companyId}/${id}`,
            data,
            {
                reportProgress: true,
                observe: 'events',
            },
        );
    }

    public download({ id, target }: { id: string; target: 'file.docx' | 'preview-file.pdf' }): Observable<any> {
        return this.http.get(`${WordTemplatesService.BASE_URL}/${this.authService.companyId}/${id}/${target}`, {
            responseType: 'blob',
            observe: 'response',
        });
    }

    public delete({ id }: { id: string }): Observable<WordTemplate> {
        return this.http.delete<WordTemplate>(`${WordTemplatesService.BASE_URL}/${this.authService.companyId}/${id}`);
    }
}
